// extracted by mini-css-extract-plugin
export default {"content_flex":"Footer_content_flex__a6ESO","footer_card":"Footer_footer_card__R3Wbd","logo":"Footer_logo__w79hm","icon_wrap":"Footer_icon_wrap__jlOg+","icon":"Footer_icon__ctCoM"};